import OrdersTableHead from "./OrdersTableHead";

export default OrdersTableHead;